export * from './barrier-name.pipe';
export * from './barrier-height.pipe';
export * from './barrier-photo.pipe';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/index.ts